import { render, staticRenderFns } from "./OrderKanban.vue?vue&type=template&id=7d2b8c86&scoped=true&"
import script from "./OrderKanban.vue?vue&type=script&lang=js&"
export * from "./OrderKanban.vue?vue&type=script&lang=js&"
import style0 from "~/components/orderKanban/OrderKanban.scss?vue&type=style&index=0&id=7d2b8c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2b8c86",
  null
  
)

export default component.exports